import { render, staticRenderFns } from "./MentorInvite.vue?vue&type=template&id=b35fde10&"
import script from "./MentorInvite.vue?vue&type=script&lang=js&"
export * from "./MentorInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports